module.exports = __webpack_public_path__ + "static/media/img30-4.9f9c2ee5.jpg";